import { render } from "./MessagesComp.vue?vue&type=template&id=41314137"
import script from "./MessagesComp.vue?vue&type=script&lang=js"
export * from "./MessagesComp.vue?vue&type=script&lang=js"

import "./MessagesComp.vue?vue&type=style&index=0&id=41314137&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__